import React from 'react'

export const Button = ({text, type="button", onSubmit, style={}, classNames = '', disabled = false, size = 'medium', onClick}) => {
  return (
    <button style={style} type={type} disabled={disabled} className={`button ${size} ${classNames} dark-theme-bg0`} onClick={onClick}>{text}</button>
  )
}
